var exports = {
  "q": "GifIndicator.module__indicator___aVBVaD",
};

module.exports = exports;
